export default __webpack_public_path__ + "guide--imagery-sakurajima-480-45f7d8bf43a3fc369b9c337fd86b7eda.png";